import { render } from "./apexStudentChartSuccess.vue?vue&type=template&id=b8b81f26&scoped=true"
import script from "./apexStudentChartSuccess.vue?vue&type=script&lang=js"
export * from "./apexStudentChartSuccess.vue?vue&type=script&lang=js"

import "./apexStudentChartSuccess.vue?vue&type=style&index=0&id=b8b81f26&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b81f26"]])

export default __exports__